import { styled } from '@mui/system';

import { AppBar, Box, Toolbar, Typography, IconButton, ListItemButton } from '@mui/material';
import BaseCTAButton from '../../ui/ctaButton';

import { Link } from 'react-router-dom';
import { colors } from '../../constants/theme';

export const Navbar = styled(AppBar, {
  shouldForwardProp: (prop) => !['isVisible', 'isAtTop'].includes(prop),
})(({ theme, isVisible, isAtTop }) => ({
  backgroundColor: !isAtTop && isVisible ? '#E6EBF0' : 'transparent',
  boxShadow: !isAtTop && isVisible ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
  color: '#4c2e1f',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1100,
  transform: isVisible ? 'translateY(0)' : 'translateY(-100%)',
  transition: 'background-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease',
}));

export const HeaderPlaceholder = styled(Box)({
  width: '100%',
});

export const HeaderContent = styled(Box)({
  width: '100%',
  maxWidth: '1400px',
  height: '128px',
  margin: '0 auto',
  alignContent: 'center',
});

export const HeaderToolbar = styled(Toolbar)(({ theme }) => ({
  '&&': {
    display: 'flex',
    alignItems: 'center',
    minHeight: 80,
    paddingLeft: '38px',
    paddingRight: '38px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      minHeight: 72,
      paddingLeft: '16px',
      paddingRight: '16px',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      paddingLeft: '38px',
      paddingRight: '38px',
    },
  },
}));

export const NavLinks = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '21px',
  alignItems: 'center',
  zIndex: 2,

  [theme.breakpoints.down(1300)]: {
    gap: '10px',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledButtonWrapper = styled(Box)({
  display: 'inline-block',
});

export const StyledLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
});

export const NavLinkText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ isActive, theme }) => ({
  cursor: 'pointer',
  color: isActive ? colors.calmBlue : colors.primary,
  fontFamily: 'Quicksand, sans-serif',
  fontWeight: isActive ? 700 : 500,
  whiteSpace: 'nowrap',
  fontSize: '18px',
  letterSpacing: '0',
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',
  '&::after': {
    content: 'attr(data-text)',
    fontWeight: 700,
    height: 0,
    visibility: 'hidden',
    overflow: 'hidden',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  [theme.breakpoints.down(1200)]: {
    fontSize: '16px',
  },
}));

export const LogoContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const Logo = styled('img', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  width: isMobile ? '240px' : '391px',
  height: isMobile ? '62px' : '95px',
  objectFit: 'contain',
  cursor: 'pointer',
}));

export const CTAButton = styled(BaseCTAButton, {
  shouldForwardProp: (prop) => prop !== 'isMobile' && prop !== 'customStyles',
})(({ isMobile, customStyles }) => ({
  color: '#FFF',
  backgroundColor: '#29405A',
  fontFamily: 'Quicksand, sans-serif',
  fontSize: '20px',
  fontWeight: 500,
  padding: '15px 20px',
  textTransform: 'none',
  borderRadius: '10px',
  zIndex: 1000,
  whiteSpace: 'nowrap',
  letterSpacing: '-.4px',
  border: 'none',
  lineHeight: '13px',
  width: '100%',
  marginLeft: '10px',
  '&:hover': {
    backgroundColor: '#1e3245',
  },
  // ...customStyles,
}));

export const BurgerButton = styled(IconButton)({
  color: colors.primary,
  padding: '0',
  margin: '12px',
});

export const DrawerContent = styled(Box)({
  width: '85vw',
  maxWidth: 360,
  padding: '16px',
  paddingTop: '12px',
});

export const DrawerLogoContainer = styled(Box)({
  marginBottom: '12px',
  display: 'flex',
  justifyContent: 'center',
});

export const DrawerLogo = styled('img')({
  width: 200,
  height: 52,
  objectFit: 'contain',
  cursor: 'pointer',
});

export const DrawerNavItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ isActive }) => ({
  borderRadius: '4px',
  '&.Mui-selected': {
    background: 'rgba(41,64,90,0.08)',
  },
}));

export const DrawerNavText = {
  fontFamily: 'Quicksand, sans-serif',
  fontSize: 16,
  color: colors.primary,
};

export const DrawerButtonContainer = styled(Box)({
  paddingLeft: '8px',
  paddingRight: '8px',
});

export const UICTAButton = styled(CTAButton)({
  whiteSpace: 'nowrap',
  margin: 'auto',
});
